import React, { useState, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import slugify from 'slugify'
import Modal from 'react-modal'
import DeleteMealModal from './DeleteMealModal.jsx'
import { removeSpecificMeal } from '../../../../Api/dietApi/userInfo'
import { isMobile } from 'react-device-detect'

import {
  MealsListContainer,
  MealBox,
  MealCalorieValue,
  MealIngredientContainer,
  AddIngredientButton,
  RemoveMealButton,
  MealRow,
} from './MealsListStyles'

import {
  // HorizontalDivider,
  TextHeaderRow,
  MealIngredientName,
  MealIngredientKcalValue,
  MealIngredientWeightValue,
  MealIngredientRow,
} from '../../Shared/SharedStyledComponents'

import ProductIcon from '../../../../assets/REDESIGN_Assets/Diet/product-icon.svg'
import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericIcon from '../../../../GenericComponents/GenericIcon'
import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan.js'
import GenericColumn from '../../../../GenericComponents/GenericColumn.js'

interface MealsListProps {
  userDailyBalance: any
  meals: any
  sniadanie: any
  IIsniadanie: any
  obiad: any
  przekaska: any
  kolacja: any
  todayDate: any
  chosenDate: any
  removeMeal: any
  challengeMode: boolean
}

const MealsList: React.FC<MealsListProps> = ({
  userDailyBalance,
  meals,
  sniadanie,
  IIsniadanie,
  obiad,
  przekaska,
  kolacja,
  todayDate,
  chosenDate,
  removeMeal,
  challengeMode
}) => {
  let history = useHistory()
  const location = useLocation()

  const goToMealsScreen = (mealType: string) => {
    history.push({
      pathname: `/dieta/${mealType}/${chosenDate ? chosenDate : todayDate
        }/gotowe-posilki`,
      chosedMealType: mealType,
      todayDate: todayDate,
      chosenDate: chosenDate,
      challengeMode: challengeMode
    })
  }

  const goToSpecificMeal = (mealId: any, mealName: any, meal: any) => {
    history.push({
      pathname: `/dieta/szczegoly-posilku/${chosenDate ? chosenDate : todayDate
        }/${mealId}/${slugify(mealName)}/`,
      state: {
        chosedMeal: meal,
        chosedMealType: meal.meal_type,
        todayDate: todayDate,
        chosenDate: chosenDate,
        challengeMode: challengeMode
      },
    })
  }

  const deleteMealModalEl = useRef(null)
  const [isDeleteMealModalOpen, setDeleteModalOpen] = useState(false)
  const [deleteItemName, setDeleteItemName] = useState('')
  const [deleteItemId, setDeleteItemId] = useState('')

  const closeDeleteMealModal = () => {
    setDeleteModalOpen(false)
  }
  const openDeleteMealModal = () => {
    setDeleteModalOpen(true)
  }

  Modal.setAppElement('#root')

  const removeElement = () => {
    removeSpecificMeal(deleteItemId)
    closeDeleteMealModal()
    setTimeout(() => {
      window.location.reload()
    }, 200)
  }

  const removeMealHandler = (e: any, mealId: any, mealName: any) => {
    setDeleteItemName(mealName)
    setDeleteItemId(mealId)
    openDeleteMealModal()
  }

  const customModalStyles = {
    overlay: { zIndex: 1000, backgroundColor: `rgba(0, 0, 0, 0.5)` },
    content: {
      // zIndex: '15',
      right: `unset`,
      bottom: `unset`,
      top: !isMobile ? `50%` : `37%`,
      left: !isMobile ? `50%` : `0%`,
      transform: !isMobile ? `translate(-50%, -50%)` : `translate(0%, 0%)`,
      padding: `10px 15px`,
      minWidth: !isMobile ? `400px` : 'unset',
      // maxHeight: '50%',
      height: isMobile ? '25%' : 'unset',
      width: isMobile ? '92%' : '550px',
    },
  }

  return (
    <MealsListContainer>
      <MealBox>
        <GenericRow>
          <TextHeaderRow align="left" fontSize={27}>
            Śniadanie
          </TextHeaderRow>
          <MealCalorieValue>
            {meals &&
              meals.map((meal: any) =>
                meal && meal.meal_type_name == 'Śniadanie'
                  ? `${meal.total_kcal.amount != null
                    ? meal.total_kcal.amount
                    : 0
                  } kcal`
                  : null
              )}
          </MealCalorieValue>
        </GenericRow>

        {sniadanie &&
          sniadanie.map((meal: any) => (
            <MealIngredientContainer>
              <MealRow>
                <MealIngredientRow
                  justify="flex-start"
                  width="80%"
                  flexDirection={'row'}
                  onClick={() =>
                    goToSpecificMeal(meal.meal_id, meal.name, meal)
                  }
                >
                  <GenericRow>
                    <GenericColumn width={'60%'} align="flex-start">
                      <GenericTextSpan tAlign="left">
                        {meal.name}
                      </GenericTextSpan>
                    </GenericColumn>
                    <GenericColumn width={'40%'}>
                      <GenericTextSpan>
                        {meal.calories.amount} kcal
                      </GenericTextSpan>
                    </GenericColumn>
                  </GenericRow>
                </MealIngredientRow>
                <RemoveMealButton
                  onClick={(e: any) => removeMealHandler(e, meal.id, meal.name)}
                ></RemoveMealButton>
              </MealRow>
              {/* <MealIngredientRow>
                <MealIngredientWeightValue>252g</MealIngredientWeightValue>
              </MealIngredientRow> */}
            </MealIngredientContainer>
          ))}

        <AddIngredientButton onClick={() => goToMealsScreen('sniadanie')} />
      </MealBox>

      <MealBox>
        <GenericRow>
          <TextHeaderRow align="left" fontSize={27}>
            II Śniadanie
          </TextHeaderRow>
          <MealCalorieValue>
            {meals &&
              meals.map((meal: any) =>
                meal && meal.meal_type_name == 'II śniadanie'
                  ? `${meal.total_kcal.amount != null
                    ? meal.total_kcal.amount
                    : 0
                  } kcal`
                  : null
              )}
          </MealCalorieValue>
        </GenericRow>

        {IIsniadanie &&
          IIsniadanie.map((meal: any) => (
            <MealIngredientContainer>
              <MealRow>
                <MealIngredientRow
                  justify="flex-start"
                  width="80%"
                  flexDirection={'row'}
                  onClick={() =>
                    goToSpecificMeal(meal.meal_id, meal.name, meal)
                  }
                >
                  <GenericRow>
                    <GenericColumn width={'60%'} align="flex-start">
                      <GenericTextSpan tAlign="left">
                        {meal.name}
                      </GenericTextSpan>
                    </GenericColumn>
                    <GenericColumn width={'40%'}>
                      <GenericTextSpan>
                        {meal.calories.amount} kcal
                      </GenericTextSpan>
                    </GenericColumn>
                  </GenericRow>
                </MealIngredientRow>

                <RemoveMealButton
                  onClick={(e: any) => removeMealHandler(e, meal.id, meal.name)}
                ></RemoveMealButton>
              </MealRow>
            </MealIngredientContainer>
          ))}
        <AddIngredientButton onClick={() => goToMealsScreen('IIsniadanie')} />
      </MealBox>

      <MealBox>
        <GenericRow>
          <TextHeaderRow align="left" fontSize={27}>
            Obiad
          </TextHeaderRow>
          <MealCalorieValue>
            {meals &&
              meals.map((meal: any) =>
                meal && meal.meal_type_name == 'Obiad'
                  ? `${meal.total_kcal.amount != null
                    ? meal.total_kcal.amount
                    : 0
                  } kcal`
                  : null
              )}
          </MealCalorieValue>
        </GenericRow>
        {obiad &&
          obiad.map((meal: any) => (
            <MealIngredientContainer>
              <MealRow>
                <MealIngredientRow
                  justify="flex-start"
                  width="80%"
                  flexDirection={'row'}
                  onClick={() =>
                    goToSpecificMeal(meal.meal_id, meal.name, meal)
                  }
                >
                  <GenericRow>
                    <GenericColumn width={'60%'} align="flex-start">
                      <GenericTextSpan tAlign="left">
                        {meal.name}
                      </GenericTextSpan>
                    </GenericColumn>
                    <GenericColumn width={'40%'}>
                      <GenericTextSpan>
                        {meal.calories.amount} kcal
                      </GenericTextSpan>
                    </GenericColumn>
                  </GenericRow>
                </MealIngredientRow>
                {/* <MealIngredientRow>
                <MealIngredientWeightValue>252g</MealIngredientWeightValue>
              </MealIngredientRow> */}
                <RemoveMealButton
                  onClick={(e: any) => removeMealHandler(e, meal.id, meal.name)}
                ></RemoveMealButton>
              </MealRow>
            </MealIngredientContainer>
          ))}
        <AddIngredientButton onClick={() => goToMealsScreen('obiad')} />
      </MealBox>

      <MealBox>
        <GenericRow>
          <TextHeaderRow align="left" fontSize={27}>
            Przekąska
          </TextHeaderRow>
          <MealCalorieValue>
            {meals &&
              meals.map((meal: any) =>
                meal && meal.meal_type_name == 'Przekąska'
                  ? `${meal.total_kcal.amount != null
                    ? meal.total_kcal.amount
                    : 0
                  } kcal`
                  : null
              )}
          </MealCalorieValue>
        </GenericRow>
        {przekaska &&
          przekaska.map((meal: any) => (
            <MealIngredientContainer>
              <MealRow>
                <MealIngredientRow
                  justify="flex-start"
                  width="80%"
                  flexDirection={'row'}
                  onClick={() =>
                    goToSpecificMeal(meal.meal_id, meal.name, meal)
                  }
                >
                  <GenericRow>
                    <GenericColumn width={'60%'} align="flex-start">
                      <GenericTextSpan tAlign="left">
                        {meal.name}
                      </GenericTextSpan>
                    </GenericColumn>
                    <GenericColumn width={'40%'}>
                      <GenericTextSpan>
                        {meal.calories.amount} kcal
                      </GenericTextSpan>
                    </GenericColumn>
                  </GenericRow>
                </MealIngredientRow>
                {/* <MealIngredientRow>
                <MealIngredientWeightValue>252g</MealIngredientWeightValue>
              </MealIngredientRow> */}
                <RemoveMealButton
                  onClick={(e: any) => removeMealHandler(e, meal.id, meal.name)}
                ></RemoveMealButton>
              </MealRow>
            </MealIngredientContainer>
          ))}
        <AddIngredientButton onClick={() => goToMealsScreen('przekaska')} />
      </MealBox>

      <MealBox>
        <GenericRow align="center" justify="center">
          <TextHeaderRow align="left" fontSize={27}>
            Kolacja
          </TextHeaderRow>
          <MealCalorieValue>
            {meals &&
              meals.map((meal: any) =>
                meal && meal.meal_type_name == 'Kolacja'
                  ? `${meal.total_kcal.amount != null
                    ? meal.total_kcal.amount
                    : 0
                  } kcal`
                  : null
              )}
          </MealCalorieValue>
        </GenericRow>
        {kolacja &&
          kolacja.map((meal: any) => (
            <MealIngredientContainer>
              <MealRow>
                <MealIngredientRow
                  onClick={() =>
                    goToSpecificMeal(meal.meal_id, meal.name, meal)
                  }
                  flexDirection={'row'}
                  justify="flex-start"
                  width="80%"
                >
                  <GenericRow>
                    <GenericColumn width={'60%'} align="flex-start">
                      <GenericTextSpan tAlign="left">
                        {meal.name}
                      </GenericTextSpan>
                    </GenericColumn>
                    <GenericColumn width={'40%'}>
                      <GenericTextSpan>
                        {meal.calories.amount} kcal
                      </GenericTextSpan>
                    </GenericColumn>
                  </GenericRow>
                </MealIngredientRow>
                {/* <MealIngredientRow>
                <MealIngredientWeightValue>252g</MealIngredientWeightValue>
              </MealIngredientRow> */}
                <RemoveMealButton
                  onClick={(e: any) => removeMealHandler(e, meal.id, meal.name)}
                ></RemoveMealButton>
              </MealRow>
            </MealIngredientContainer>
          ))}
        <AddIngredientButton onClick={() => goToMealsScreen('kolacja')} />
      </MealBox>

      <Modal
        ref={deleteMealModalEl}
        isOpen={isDeleteMealModalOpen}
        onRequestClose={closeDeleteMealModal}
        style={customModalStyles}
      >
        <DeleteMealModal
          removeMeal={removeMeal}
          modalClose={closeDeleteMealModal}
          deleteItemName={deleteItemName}
          removeElement={removeElement}
        />
      </Modal>
    </MealsListContainer>
  )
}

export default MealsList
